import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './services/sentry';
import './index.css';
import App from './App';

initSentry();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
